import React from 'react';
import { Button, Modal, Message } from 'semantic-ui-react';
import { ADDRESS_NOT_FOUND_TEXT, ADDRESS_NOT_FOUND_HELP_TEXT } from './NoAddressSuggestionsDisplay.constants';
import AddressEnteredDisplay from '../AddressEnteredDisplay';
function NoAddressSuggestionsDisplay(_ref) {
  var open = _ref.open,
    manualAddress = _ref.manualAddress,
    onCancel = _ref.onCancel;
  return /*#__PURE__*/React.createElement(Modal, {
    open: open
  }, /*#__PURE__*/React.createElement(Modal.Header, null, "We couldn't find a formatted address"), /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement("p", null, ADDRESS_NOT_FOUND_TEXT), /*#__PURE__*/React.createElement(AddressEnteredDisplay, {
    address: manualAddress
  }), /*#__PURE__*/React.createElement(Message, null, ADDRESS_NOT_FOUND_HELP_TEXT)), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    onClick: onCancel
  }, "Got it")));
}
export default NoAddressSuggestionsDisplay;